import { provideTopLevelClientConfigs } from './client-config.module';
import { provideNavigationBootstrap } from './navigation-bootstrap.feature';

export function providePokerCoreFeatures() {
    return provideTopLevelClientConfigs().concat(provideNavigationBootstrap());
}
